import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import classNames from 'classnames';

import Top2BoxEndSpacer from '../Top2BoxEndSpacer';
import Top2BoxItem from '../Top2BoxItem';
import styles from './_index.module.scss';

const Top2BoxColumn = ({ id, items, onClear, onRemoveItem, placeholder, title }) => {
  const isListEmpty = items?.length === 0;

  return (
    <Droppable direction="vertical" droppableId={id}>
      {(provided, snapshot) => (
        <div
          className={classNames(styles['top-2-box-column'], {
            [styles['is-empty']]: isListEmpty,
          })}
          data-is-over={snapshot.isDraggingOver || undefined}
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          {(!!title || (!!items?.length && !!onClear)) && (
            <div className={styles['top-2-box-column-header']}>
              {title && (
                <h3>
                  {title}
                  {items?.length ? ` (${items.length})` : ''}
                </h3>
              )}

              {!!items?.length && onClear && (
                <button className={styles['top-2-box-clear']} onClick={onClear} type="button">
                  Clear
                </button>
              )}
            </div>
          )}

          <div>
            {items.length === 0 && placeholder && (
              <div className={styles['top-2-box-empty']}>{placeholder}</div>
            )}

            {items.map((item, index) => (
              <Top2BoxItem index={index} item={item} key={item.id} onRemove={onRemoveItem} />
            ))}
            <Top2BoxEndSpacer droppableId={id} index={items.length} />
            {provided.placeholder}
          </div>
        </div>
      )}
    </Droppable>
  );
};

Top2BoxColumn.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, label: PropTypes.string.isRequired })
  ).isRequired,
  onClear: PropTypes.func,
  onRemoveItem: PropTypes.func,
  placeholder: PropTypes.string,
  title: PropTypes.string,
};

export default Top2BoxColumn;
